import React from 'react';

export const ScopesContext = React.createContext({});
